import * as React from 'react';

import {List} from '@common/typescript/objects/List';

import Musthead from '@app/components/UI/MustHead/Musthead';
import LinkBlockSmall from '@app/components/UI/LinkBlock/LinkBlockSmall';
import RichText from '@app/components/UI/RichText/RichText';
import FaqBlock from '@app/components/UI/FaqBlock/FaqBlock';
import VideoEmbed from '@app/components/UI/VideoEmbed/VideoEmbed';
import {Questions} from '@app/objects/Questions';
import {rest} from '@app/components/Api';
import FaqBlockHeaderSm from '@app/components/UI/FaqBlock/FaqBlockHeaderSm';
import {
	disclaimer, linkItems,
	teleadviceEmbedText,
	teleadviceMustheadText,
	teleadviceRichText1, teleadviceRichText2
} from '@app/components/Pages/Services/Teleadvice/TeleadviceContent';
import SloganBlockSmall from '@app/components/UI/SloganBlock/SloganBlockSmall';
import GetInTouchButton from '@app/components/Forms/GetInTouch/GetInTouchButton';
import withSeo from '@app/components/LocalCommon/HigherOrderComponents/WithSeo';
import {homeSliderVetTitle} from '@app/components/Pages/Home/homeContent';
import {Veterinarian} from '@app/objects/Veterinarian';
import SliderVet from '@app/components/UI/Slider/SliderVet';
import listenerForBrowser from '@app/components/Pages/listenerForBrowser';

const Teleadvice = () => {
	const [questions, setQuestions] = React.useState<Questions[]>([]);
	const [isMobile, setIsMobile] = React.useState(false);
	const [vetList, setVetList] = React.useState<Veterinarian[]>([]);

	React.useEffect(() => {
		rest.get<List<Questions>>('v1/faq/teleadvicePage').then(res => setQuestions(res.list));
		rest.get<List<Veterinarian>>('v1/veterinarians/Teleadvice').then(res => setVetList(res.list));
	}, []);

	React.useEffect(() => {
		const mql = window.matchMedia('screen and (max-width: 600px)');

		const listenerFunc = () => {
			if (mql.matches) {
				setIsMobile(true);
			} else {
				setIsMobile(false);
			}
		};
		listenerFunc();
		listenerForBrowser(mql, listenerFunc);
	}, []);

	return(
		<div className="teleadvice our-services">
			<Musthead
				title="Telehospice"
				imageSrc={require('@app/content/teleadviceHead.jpg')}
				text={teleadviceMustheadText}
				quoteAuthor="The Fiera Family"
				imageAlt="Pet euthanasia near me"
			/>
			<VideoEmbed text={teleadviceEmbedText} />
			<RichText
				title="What to expect from telehospice"
				text={teleadviceRichText1}
			/>
			<RichText
				title="Telehospice sessions help answer questions like these:"
				text={teleadviceRichText2}
			/>

			<SloganBlockSmall
				title="Schedule a telehospice consultation with one of our doctors"
				btnText={isMobile ? <a className="btn btn-md btn-primary" href="tel:855-933-5683">Call Us</a> : <GetInTouchButton />}
				onBtnClick={() => {}}
				text={disclaimer}
				styled="slogan-block-small_white"
			/>
			<SliderVet
				subtitle="Our veterinarians"
				title={homeSliderVetTitle}
				location={'Viewing Telehospice Vets'}
				items={vetList}
				teleadviceCapture={'Telehospice'}
				hideReadMore={true}
			/>
			<div className="care-coordinator__faq">
				<div className="care-coordinator__faq-content">
					<FaqBlockHeaderSm
						title="You might find yourself asking..."
						btnText="View all FAQ"
						clickUrl="/faq"
					/>
					<FaqBlock questions={questions} />
				</div>
			</div>
			<LinkBlockSmall items={linkItems} />
		</div>
	);
};

export default withSeo(Teleadvice, state => state.teleadvicePage, 'teleadvicePage', 'our-services/telehospice');